/**
 * TanStack Query hooks for `campaign-geo-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignGeoTargetingQueryKeys,
	type CreateCampaignGeoTargetingBody,
	type ListCampaignGeoTargetingResponse,
	type CampaignGeoTargetingRow,
} from "./api";

export function useCampaignGeoTargetingList(): UseQueryResult<ListCampaignGeoTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignGeoTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignGeoTargetingCreate(): UseMutationResult<CampaignGeoTargetingRow, Error, CreateCampaignGeoTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignGeoTargetingQueryKeys.all });
		},
	});
}

export function useCampaignGeoTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignGeoTargetingQueryKeys.all });
		},
	});
}
